import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SmallReportItem from './smallItem';
import ReportItem, { reportPropType } from './item';

function ReportsSubList({
  reports, compactView, favorites, onToggleFavorites,
}) {
  return (
    <Row className="w-100 gy-3">
      {reports.map((report, idx) => (
        <Col
          xs={12}
          sm={compactView ? 2 : 4}
          md={compactView ? 2 : 4}
          lg={compactView ? 2 : 4}
          key={report.id}
        >
          {compactView ? (
            <SmallReportItem
              report={report}
              inFavorites={favorites.includes(report.id)}
              onToggleFavorites={onToggleFavorites}
              compactView={compactView}
            />
          ) : (
            <ReportItem
              report={report}
              idx={idx}
              inFavorites={favorites.includes(report.id)}
              onToggleFavorites={onToggleFavorites}
              compactView={compactView}
            />
          )}
        </Col>
      ))}
    </Row>

  );
}

ReportsSubList.propTypes = {
  reports: PropTypes.arrayOf(reportPropType).isRequired,
  favorites: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleFavorites: PropTypes.func.isRequired,
  compactView: PropTypes.bool.isRequired,
};

export default ReportsSubList;
